import React from "react";
import ForSaleList from "components/backend/listings/sale/index";

export default class ForSaleArchive extends React.Component {
  render() {
    return <ForSaleList status="archived" {...this.props} />;
  }
}
